import { Tabs } from 'antd';
import { Navigate, useNavigate } from 'react-router';
import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { AllExpensesTab } from '../components/AllExpensesTab';
import { ExpenseApprovalsTab } from '../components/ExpenseApprovalsTab';
import { EXPENSE_TAB_LABELS, expenseTabPath, type ExpenseTab } from '../expenses.paths';

/** Expenses → every expense, and (for those who approve) the ones waiting for their decision. */
export function ExpensesPage({ tab }: { tab: ExpenseTab }) {
  const navigate = useNavigate();
  const { state } = useCurrentUser();
  const canApprove = state.status === 'authenticated' && state.user.permissions.includes('expense.approve');

  // Hiding the tab is UX; the server refuses the queue's decisions to anyone without the permission.
  if (tab === 'approvals' && !canApprove) return <Navigate to={expenseTabPath('all')} replace />;

  const items = [
    { key: 'all', label: EXPENSE_TAB_LABELS.all, children: tab === 'all' && <AllExpensesTab /> },
    ...(canApprove ? [{ key: 'approvals', label: EXPENSE_TAB_LABELS.approvals, children: tab === 'approvals' && <ExpenseApprovalsTab /> }] : []),
  ];

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('expenses')}
        title="Expenses"
        description="Fuel, tolls and other costs drivers capture on trips and trucks, and ones the office records for them."
      />
      <Tabs activeKey={tab} onChange={(key) => navigate(expenseTabPath(key as ExpenseTab))} items={items} />
    </>
  );
}
